import React from 'react';
import "./css/404_error.css";
import { useNavigate } from 'react-router-dom';

const Error = () => {

  const navigate = useNavigate();

  //click button in delete the token
  const Funclick = () => {
   // localStorage.removeItem("authToken"); //token
    sessionStorage.clear();
    navigate("/");
  }

  return (
    <>
    <div id="card_404">
      <div id="c1">
        <h5 id="title">404</h5>
        <h5 id="error">Error</h5>
        <p id="page">Page Not Found.</p>
        <a onClick={Funclick} id="link">Go Back</a>
      </div>
    </div>
   
    </>
  )
}

export default Error;